<template>
<v-app>
    <div class="name_take_out_user_page" :style="{background: bg_color}">
        <v-container>
            <v-row class="justify-center align-center h_full_name_take_out_user">
                <v-col cols="11" sm="10" md="11" lg="5" xl="6">
                    <div>
                        <div class="logo_name_take_out_user">
                            <img :src="beforeImage">
                        </div>
                        <!-- <h2 class="text-center title_name_take_out_user mb-3">"สักหนึ่งประโยค ขอชื่อของลูกค้า"</h2> -->
                        <v-text-field placeholder="กรุณากรอกชื่อก่อนสั่งซื้ออาหาร" class="w_input_name_take_out_user" v-model="name" outlined required>
                        </v-text-field>
                        <v-btn rounded color="white" width="100%" height="65" @click="addCartTakeOutNameUser()">สั่งอาหาร</v-btn>
                    </div>
                </v-col>
            </v-row>
        </v-container>

    </div>
</v-app>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
import before_image from "@/assets/new_logo_by.png";
export default {
    name: 'nameTakeOutUser',
    data() {
        return {
            beforeImage: before_image,
            name: '',
            bg_color: 'linear-gradient(to top, #038cc1 , #55c0e9)',

        }
    },
    methods: {
        async colorRestaurant() {
            HTTP.get(`/showColor?store_id=`+this.$route.query.store_id)
                .then((response) => {
                    if (response.data.successful === true) {
                        this.bg_color = response.data.color_code
                        this.beforeImage = response.data.logo_image
                        this.loading_page = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                    if (error.response.status === 500) {
                        // this.$router.push('/nametakeoutuser')
                    }

                })
        },
        async checkCartTakeOutNameUser() {
            if (this.$store.state.cartTakeOutNameUser !== null) {
                this.$router.push('/takeoutuser')
            }
        },
        async addCartTakeOutNameUser() {

            const regex = this.name.replace(this.$store.state.checkEmoji, "")
            if (regex) {
                const namePage = {
                    name: regex
                }
                this.$store.commit('addCartTakeOutNameUser', namePage)
                this.$router.push('/takeoutuser?store_id='+this.$route.query.store_id)
            }
        }
    },
    mounted() {
        this.colorRestaurant()
        this.checkCartTakeOutNameUser()
    }
}
</script>

<style scoped>
.name_take_out_user_page {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
}

.h_full_name_take_out_user {
    height: 100%;
}

.logo_name_take_out_user {
    width: 300px;
    margin: auto;
}

.logo_name_take_out_user>img {
    max-width: 100%;
}

.title_name_take_out_user {
    color: #fff;
}

.w_input_name_take_out_user {
    width: 80%;
    margin: auto;
}

.w_input_name_take_out_user>>>input {
    text-align: center;
    color: #000;
    caret-color: #000;
}

.w_input_name_take_out_user>>>fieldset {
    color: #000 !important;
    background: #fff;
}

.w_input_name_take_out_user>>>label {
    color: #000 !important;
}

@media only screen and (max-width: 625px) {
    .w_input_name_take_out_user>>>label {
        font-size: 19px !important;
    }
}

@media only screen and (max-width: 545px) {
    .w_input_name_take_out_user>>>label {
        font-size: 17px !important;
    }
}

@media only screen and (max-width: 495px) {
    .w_input_name_take_out_user>>>label {
        font-size: 15px !important;
    }
}

@media only screen and (max-width: 445px) {
    .w_input_name_take_out_user>>>label {
        font-size: 13px !important;
    }
}

@media only screen and (max-width: 400px) {
    .w_input_name_take_out_user>>>label {
        font-size: 12px !important;
    }
}

@media only screen and (max-width: 375px) {
    .w_input_name_take_out_user>>>label {
        font-size: 11px !important;
    }
}

@media only screen and (max-width: 345px) {
    .logo_name_take_out_user {
        width: 100%;
    }

    .w_input_name_take_out_user>>>label {
        font-size: 8px !important;
    }
}
</style>
